import { render } from "./BookmarksView.vue?vue&type=template&id=24a0f544&scoped=true"
import script from "./BookmarksView.vue?vue&type=script&lang=js"
export * from "./BookmarksView.vue?vue&type=script&lang=js"

import "./BookmarksView.vue?vue&type=style&index=0&id=24a0f544&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a0f544"]])

export default __exports__